import { inferDateForAmbiguousTime, type TimeConstraints } from "./inferDateForAmbiguousTime";

export interface BreakStartConstraints {
  earliestAllowed: Date; // Clock-in time (always defined for breaks)
  latestAllowed: Date; // Clock-out time (always defined for breaks)
}

/**
 * Infers the correct date for an ambiguous break start time.
 *
 * For overnight shifts, break start times selected via time picker need
 * date inference to determine which day the user intended.
 *
 * @param ambiguousTime - Time from picker with potentially wrong date
 * @param originalBreakStartTime - Original break start time (provides date context)
 * @param constraints - Clock-in and clock-out times to constrain the break
 * @returns The break start time with correct date inferred
 */
export function inferDateForAmbiguousBreakStartTime(
  ambiguousTime: Date,
  originalBreakStartTime: Date,
  constraints: BreakStartConstraints
): Date {
  // For breaks, both constraints are always defined
  const timeConstraints: TimeConstraints = {
    earliestAllowed: constraints.earliestAllowed,
    latestAllowed: constraints.latestAllowed,
  };

  return inferDateForAmbiguousTime(ambiguousTime, originalBreakStartTime, timeConstraints);
}
